import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";


export default function AdminProfile() {
    const { profile } = useSelector((state) => state.auth);

    const navigate = useNavigate()

    const name = profile?.data?.name || "-";
    const username = profile?.data?.username || "-";
    const role = profile?.data?.role || "-";
    const email = profile?.data?.email || "-";
    const mobileNumber = profile?.data?.mobile || "-";

    const initials =
        username
            ?.split(" ")
            ?.map((word) => word[0])
            ?.join("")
            ?.slice(0, 2)
            ?.toUpperCase() || "";

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const t = setTimeout(() => setVisible(true), 80);
        return () => clearTimeout(t);
    }, []);

    const fields = [
        { icon: "bi bi-person-fill", label: "Full Name", value: name },
        { icon: "bi bi-at", label: "Username", value: username },
        { icon: "bi bi-envelope-fill", label: "Email Address", value: email },
        { icon: "bi bi-phone-fill", label: "Mobile", value: mobileNumber },
        { icon: "bi bi-shield-fill-check", label: "Role", value: role, badge: true },
    ];

    return (
        <>

            <div className="breadcrumb-bar sticky-top mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/admin/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"
                                onClick={() => navigate("/admin/profile")}
                            >
                                Profile
                            </span>
                        </div>



                    </div>
                </div>
            </div>

            <div className={`ap-root${visible ? " ap-root--in" : ""}`}>
                <div className="ap-bg-grid" aria-hidden="true" />
                <div className="ap-bg-orb ap-bg-orb--1" aria-hidden="true" />
                <div className="ap-bg-orb ap-bg-orb--2" aria-hidden="true" />

                <div className="container-fluid  px-md-2 py-1">
                    <div className="row justify-content-center g-4">

                        <div className="col-12 col-lg-4 col-xl-3">
                            <div className="ap-card ap-identity-card">
                                <div className="ap-avatar-ring">
                                    <div className="ap-avatar">
                                        <span className="ap-avatar-initials">{initials || "A"}</span>
                                        <div className="ap-avatar-pulse" />
                                    </div>
                                </div>

                                <div className="ap-identity-name mt-3">{name}</div>
                                <div className="ap-identity-username">@{username}</div>

                                <div className="ap-role-pill mt-2">
                                    <i className="bi bi-shield-fill-check me-1" />
                                    {role}
                                </div>

                                <div className="ap-divider my-3" />

                                <div className="ap-stat-row">
                                    <div className="ap-stat">
                                        <span className="ap-stat-dot ap-stat-dot--green" />
                                        <span className="ap-stat-label">Active</span>
                                    </div>
                                    <div className="ap-stat">
                                        <i className="bi bi-clock-history me-1 ap-stat-icon" />
                                        <span className="ap-stat-label">Online Now</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-8 col-xl-9">
                            <div className="ap-card ap-details-card">
                                <div className="ap-details-header">
                                    <div>
                                        <div className="ap-section-eyebrow">Account Information</div>
                                        <h2 className="ap-section-title">Profile Overview</h2>
                                    </div>

                                </div>

                                <div className="row g-3 mt-1">
                                    {fields.map((f, i) => (
                                        <div
                                            className="col-12 col-sm-6"
                                            key={f.label}
                                            style={{ animationDelay: `${0.1 + i * 0.07}s` }}
                                        >
                                            <div className="ap-field">
                                                <div className="ap-field-icon-wrap">
                                                    <i className={f.icon} />
                                                </div>
                                                <div className="ap-field-body">
                                                    <div className="ap-field-label">{f.label}</div>
                                                    {f.badge ? (
                                                        <span className="ap-badge">{f.value}</span>
                                                    ) : (
                                                        <div className="ap-field-value">{f.value}</div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>



                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}